export default "__VITE_ASSET__DHDhphMF__"